/* global googletag, apstag */
/* eslint-disable prefer-rest-params */
const TIMEOUT = 3000;
const bidders = ['a9', 'prebid'];
let requestManager = {};
function getFilteredSizeForHeaderBidding(slot) {
  // filter slot sizes that are bigger or equal to 10x10 for header bidding
  return slot?.getSizes().reduce((slotSizeAccumulator, size) => {
    if (size === 'fluid') {
      const adUnitPath = slot.getAdUnitPath() || '';
      // only remove "fluid" size if it has the path 'browse/trims'
      if (adUnitPath.includes('browse/trims')) {
        return slotSizeAccumulator;
      }
      return [...slotSizeAccumulator, size];
    }
    const dimensionArray = Object.values(size);
    const isBothSizesEqualOrBiggerThanTen = !dimensionArray.some(dimensionSize => dimensionSize < 10);

    // make sure that both of the dimension is >= 10
    if (isBothSizesEqualOrBiggerThanTen) {
      return [...slotSizeAccumulator, dimensionArray];
    }
    return slotSizeAccumulator;
  }, []);
}
function getSlotsForHeaderBidding(slots, generateSlotForHeaderBidding) {
  return slots.reduce((slotAccumulator, slot) => {
    //  getSizes() is a long existing but poorly documented googletag api. it
    //  may eventually dissappear and a different solution would be needed
    if (typeof slot?.getSizes === 'undefined') {
      // eslint-disable-next-line
      console.log("Warning: prebids's slot.getSizes() undefined.");
      return [...slotAccumulator, undefined];
    }

    // filter slot sizes that are bigger or equal to 10x10 for header bidding
    const sizeArray = getFilteredSizeForHeaderBidding(slot);
    if (sizeArray.length === 0) {
      return slotAccumulator;
    }
    const specificSlot = generateSlotForHeaderBidding(slot, sizeArray);
    return [...slotAccumulator, specificSlot];
  }, []);
}
function getPrebidAdUnits(slots, prebidAdapters) {
  return getSlotsForHeaderBidding(slots, (slot, sizeArray) => ({
    code: slot.getSlotElementId(),
    mediaTypes: {
      banner: {
        sizes: sizeArray
      }
    },
    bids: prebidAdapters || []
  }));
}
function buildBidConfig(slots) {
  return getSlotsForHeaderBidding(slots, (slot, sizeArray) => ({
    slotID: slot.getSlotElementId(),
    slotName: slot.getAdUnitPath(),
    sizes: sizeArray
  }));
}

// actually get ads from DFP
function sendAdserverRequest() {
  // return early if request already sent
  if (requestManager.adserverRequestSent === true) {
    return;
  }
  // flip the boolean that keeps track of whether the adserver request was sent
  requestManager.adserverRequestSent = true;
  // make ad request to DFP
  window.googletag.cmd.push(() => {
    window.apstag.setDisplayBids();
    window.pbjs.setTargetingForGPTAsync();
    window.googletag.pubads().refresh();
  });
}

// return true if all bidders have returned
function allBiddersBack() {
  return bidders.every(bidder => requestManager[bidder]);
}
function headerBidderBack(bidder) {
  // return early if request to adserver is already sent
  if (requestManager.adserverRequestSent === true) {
    return;
  }

  // set the bidder targeting and flip bidder back flag
  requestManager[bidder] = true;

  // if all bidders are back, send the request to the ad server
  if (allBiddersBack()) {
    sendAdserverRequest();
  }
}
function buildBidCallback(slots) {
  const slotIds = window.OWT && slots.map(slot => slot.getSlotElementId());
  return () => {
    googletag.cmd.push(() => {
      apstag.setDisplayBids();
      let owtNotice;
      if (window.OWT) {
        owtNotice = window.OWT.registerExternalBidders(slotIds);
      }
      googletag.pubads().refresh(slots);
      if (window.OWT) {
        window.OWT.notifyExternalBiddingComplete(owtNotice);
      }
    });
  };
}
export default {
  async init() {
    await new Promise((resolve, reject) => {
      try {
        // eslint-disable-next-line
        !function (a9, a, p, s, t, A, g) {
          if (a[a9]) return;
          function q(c, r) {
            a[a9]._Q.push([c, r]);
          }
          a[a9] = {
            init() {
              q('i', arguments);
            },
            fetchBids() {
              q('f', arguments);
            },
            setDisplayBids() {},
            targetingKeys() {
              return [];
            },
            _Q: []
          };
          A = p.createElement(s);
          A.async = !0;
          A.src = t;
          A.onload = () => resolve();
          g = p.getElementsByTagName(s)[0];
          g.parentNode.insertBefore(A, g);
        }('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js');

        // initialize apstag and have apstag set bids on the googletag slots when they are returned to the page
        window.apstag.init({
          pubID: '3726',
          adServer: 'googletag',
          bidTimeout: 2e3
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    });
  },
  fetchHeaderBids(data) {
    const apstagSlots = buildBidConfig(data.slots);
    const shouldFetchBid = apstagSlots.length > 0;
    const fetchBidCallBackFunction = buildBidCallback(data.slots);
    if (!data.parallelBidding) {
      if (!shouldFetchBid) {
        fetchBidCallBackFunction();
        return true;
      }
      return window.apstag.fetchBids({
        slots: apstagSlots
      }, fetchBidCallBackFunction);
    }
    // construct prebid AdUnits
    const prebidAdUnits = getPrebidAdUnits(data.slots, data.prebidAdapters);

    // create a requestManager to keep track of bidder state to determine when to send ad server
    requestManager = {
      adserverRequestSent: false,
      apstagSlots,
      adUnits: prebidAdUnits
    };

    // Add the bidders to the request manager:
    bidders.map(bidder => {
      requestManager[bidder] = false;
    });

    // request bids from prebid
    window.pbjs.que.push(() => {
      window.pbjs.addAdUnits(requestManager.adUnits);
      window.pbjs.requestBids({
        bidsBackHandler: bidResponses => {
          // console.log('bidResponses', bidResponses);
          headerBidderBack('prebid');
        }
      });
    });

    // fetch bids from APS
    if (!shouldFetchBid) {
      headerBidderBack('a9');
    } else {
      window.apstag.fetchBids({
        slots: requestManager.apstagSlots
      }, headerBidderBack('a9'));
    }

    // request the ads if bidders are not back in time.
    window.setTimeout(() => {
      sendAdserverRequest();
    }, TIMEOUT);
    return true;
  }
};